import React, { useEffect, useState, useMemo } from "react";

import {
  Container,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownItem,
  DropdownMenu,
  Nav,
  NavItem,
  NavLink,
  Row,
  Card,
  Col,
} from "reactstrap";
import classnames from "classnames";

import DeleteModal from "../../Components/Common/DeleteModal";

import BreadCrumb from "../../Components/Common/BreadCrumb";
import TableContainer from "../../Components/Common/TableContainer";
import { Rating, Published, Price } from "./ProductCol";
import { Link } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { deleteProduct, listProduct } from "./_requests";
import { useToast } from "../../Components/Common/ToastContext";
const EcommerceProducts = (props: any) => {

  const { toaster, clearToast } = useToast();

  const [productList, setProductList] = useState<any>([]);
  const [activeTab, setActiveTab] = useState<any>("1");
  const [product, setProduct] = useState<any>(null);
  const [filteredProductList, setFilteredProductList] = useState<any>([]);
  console.log("productList state", productList)
  const productLists = () => {
    listProduct().then((res: any) => {
      console.log("res listProduct", res)
      console.log("res.data listProduct", res.data)
      setProductList(res.data);
    });
  };

  useEffect(() => {
    if (toaster?.message) {
      if (toaster.status === true) {
        toast.success(toaster.message, { autoClose: 3000 });
      } else {
        toast.error(toaster.message, { autoClose: 3000 });
      }

      clearToast(); // Clear the toast data after showing
    }
  }, [toaster, clearToast]);

  useEffect(() => {
    productLists();
  }, []);

  const toggleTab = (tab: any, type: any) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      if (type === "all") {
        setFilteredProductList(productList);
      } else if (type === "published") {
        setFilteredProductList(productList.filter((product: any) => product.publishStatus === 2));
      } else if (type === "draft") {
        setFilteredProductList(productList.filter((product: any) => product.publishStatus === 1));
      } else {
        setFilteredProductList(productList);
      }
    }
  };

  useEffect(() => {
    setFilteredProductList(productList);
  }, [productList]);

  useEffect(() => {
    const sliderq = document.getElementById("product-price-range");
    sliderq?.setAttribute("data-slider-color", "success");
  }, []);



  const [deleteModalMulti, setDeleteModalMulti] = useState<boolean>(false);

  const [dele, setDele] = useState(0);

  // Displat Delete Button
  const displayDelete = () => {
    const ele = document.querySelectorAll(".productCheckBox:checked");
    const del = document.getElementById("selection-element") as HTMLElement;
    setDele(ele.length);
    if (ele.length === 0) {
      del.style.display = "none";
    } else {
      del.style.display = "block";
    }
  };


  const columns = useMemo(
    () => [
      {
        header: "#",
        accessorKey: "id",
        enableColumnFilter: false,
        enableSorting: false,
        cell: (cell: any) => {
          return (
            <input
              type="checkbox"
              className="productCheckBox form-check-input"
              value={cell.getValue()}
              onClick={() => displayDelete()}
            />
          );
        },
      },
      {
        header: "Product",
        accessorKey: "name",
        enableColumnFilter: false,
        cell: (cell: any) => (
          <>
            <div className="d-flex align-items-center">
              <div className="flex-shrink-0 me-3">
                <div className="avatar-sm bg-light rounded p-1">
                  <img
                    src={cell.row.original?.icon}
                    alt=""
                    style={{
                      height: "50px",
                      width: "50px", // Set width to 100% to fit container
                      objectFit: "cover", // Maintain aspect ratio
                    }}
                    className="img-fluid d-block"

                  />
                </div>
              </div>
              <div className="flex-grow-1">
                <h5 className="fs-14 mb-1">
                  <Link
                    to={`/products/view/${cell.row.original.id}`}
                    className="custom-redirect-link"
                  // className="text-body"
                  >
                    {" "}
                    {cell.getValue()}
                  </Link>
                </h5>
                <p className="text-muted mb-0">
                  Category :{" "}
                  <span className="fw-medium">
                    {" "}
                    {cell.row.original.categories?.name}
                  </span>
                </p>
              </div>
            </div>
          </>
        ),
      },

      {
        header: "Price",
        accessorKey: "price",
        enableColumnFilter: false,
        cell: (cell: any) => {
          const variants = cell.row.original.variants;

          return (
            <div className="text-muted mb-0 border border-gray-300 rounded p-2">
              {variants && variants.length > 0 ? (
                variants.map((variant: any, index: number) => {
                  const symbol = variant.offer_type == 1 ? "₹" : variant.offer_type == 2 ? "%" : "";
                  const hasOffer = variant.offer_value > 0;

                  return (
                    <div key={index} className="border-b last:border-b-0 py-1">
                      {variant.variant_value} {variant.variant?.name}:
                      {hasOffer ? (
                        <>
                          <p className="text-muted m-0" style={{ textDecoration: "line-through", display: "inline-block", marginLeft: "6px" }}>
                            ₹{variant?.mrp || "0.00"}
                          </p>
                          <span className="fw-medium ms-2 fw-bold">₹{variant.actual_amount}</span>
                          <span className="text-danger ms-2">
                            (-{variant.offer_value}
                            {symbol})
                          </span>
                        </>
                      ) : (
                        <span className="fw-medium ms-2 fw-bold">₹{variant?.actual_amount || "0.00"}</span>
                      )}
                    </div>
                  );
                })
              ) : (
                "N/A"
              )}
            </div>
          );
        },
      },



      // {
      //   header: "Stock",
      //   accessorKey: "stock",
      //   enableColumnFilter: false,
      //   cell: (cell: any) => {
      //     const variants = cell.row.original.variants;
      //     return (
      //       <div className="text-muted mb-0">
      //         {variants && variants.length > 0 ? (
      //           variants.map((variant: any, index: number) => (
      //             <div key={index}>
      //               {variant.variant_value} {variant.variant?.name}:{" "}
      //               <span className="fw-medium">{variant.stock}</span>
      //             </div>
      //           ))
      //         :(
      //           "N/A"
      //         )}
      //       </div>
      //     );
      //   },
      // },
      {
        header: "Publish",
        accessorKey: "publishStatus",
        enableColumnFilter: false,
        cell: (cell: any) => {
          const value = cell.getValue();
          let text = "-";
          let colorClass = "text-muted";

          switch (value) {
            case 1:
              text = "Draft";
              colorClass = "text-warning";
              break;
            case 2:
              text = "Published";
              colorClass = "text-success";
              break;
            case 3:
              text = "Scheduled";
              colorClass = "text-primary";
              break;
            default:
              text = "Unpublished";
              colorClass = "text-muted";
          }

          return (
            <div className={`d-flex align-items-center fw-medium ${colorClass}`}>
              {text}
            </div>
          );
        },
      },

      {
        header: "Visibility",
        accessorKey: "visibility",
        enableColumnFilter: false,
        cell: (cell: any) => {
          const value = cell.getValue();
          let text = "-";
          let colorClass = "text-muted";

          switch (value) {
            case 1:
              text = "Hidden";
              colorClass = "text-danger";
              break;
            case 2:
              text = "Public";
              colorClass = "text-success";
              break;
            default:
              text = "Unknown";
              colorClass = "text-muted";
          }

          return (
            <div className={`d-flex align-items-center fw-medium ${colorClass}`}>
              {text}
            </div>
          );
        },
      },


      // {
      //   header: "Rating",
      //   accessorKey: "rating",
      //   enableColumnFilter: false,
      //   cell: (cell: any) => {
      //     return <Rating {...cell} />;
      //   },
      // },
      {
        header: "Rating",
        accessorKey: "rating",
        enableColumnFilter: false,
        cell: (cell: any) => (
          <div className="text-warning">
            <i className="ri-star-fill me-1"></i>
            {cell.getValue() || "0.00"}
          </div>
        ),
      },
      {
        header: "Order",
        accessorKey: "list_order",
        enableColumnFilter: false,
        cell: (cell: any) => (
          <span className="badge bg-light text-body border">
            {cell.getValue() || 0}
          </span>
        ),
      },
      {
        header: "Published",
        accessorKey: "publishedDate",
        enableColumnFilter: false,
        cell: (cell: any) => {
          return <Published {...cell} />;
        },
      },

    ],
    []
  );
  document.title = " Paal Dappa | Admin panel";
  const allProducts = productList || [];
  const publishedProducts = allProducts.filter((item: any) => item.publishStatus == 2);
  const draftProducts = allProducts.filter((item: any) => item.publishStatus == 1);
  return (
    <div className="page-content">
      <ToastContainer closeButton={false} limit={1} />
      <DeleteModal
        show={deleteModalMulti}
        onDeleteClick={() => {
          // deleteMultiple();
          setDeleteModalMulti(false);
        }}
        onCloseClick={() => setDeleteModalMulti(false)}
      />
      <Container fluid>
        <BreadCrumb title="Products" pageTitle="Paal Dappa" />

        <Row>
          <Col xl={12} lg={12}>
            <div>
              <Card>
                <div className="card-header border-0">
                  <Row className=" align-items-center">
                    <Col>
                      <Nav
                        className="nav-tabs-custom card-header-tabs border-bottom-0"
                        role="tablist"
                      >
                        <NavItem>
                          <NavLink
                            className={classnames(
                              { active: activeTab === "1" },
                              "fw-semibold"
                            )}
                            onClick={() => {
                              toggleTab("1", "all");
                            }}
                            href="#"
                          >
                            All {" "}
                            <span className="badge bg-danger-subtle text-danger align-top rounded-pill ms-1">
                              ({allProducts?.length})
                            </span>
                          </NavLink>
                        </NavItem>
                        <NavItem>
                          <NavLink
                            className={classnames(
                              { active: activeTab === "2" },
                              "fw-semibold"
                            )}
                            onClick={() => {
                              toggleTab("2", "published");
                            }}
                            href="#"
                          >
                            Published{" "}
                            <span className="badge bg-danger-subtle text-danger align-top rounded-pill ms-1">
                              ({publishedProducts?.length})
                            </span>
                          </NavLink>
                        </NavItem>
                        <NavItem>
                          <NavLink
                            className={classnames(
                              { active: activeTab === "3" },
                              "fw-semibold"
                            )}
                            onClick={() => {
                              toggleTab("3", "draft");
                            }}
                            href="#"
                          >
                            Draft
                            <span className="badge bg-danger-subtle text-danger align-top rounded-pill ms-1">
                              ({draftProducts?.length})
                            </span>
                          </NavLink>
                        </NavItem>
                      </Nav>
                    </Col>
                    <div className="col-auto">
                      <div id="selection-element">
                        <div className="my-n1 d-flex align-items-center text-muted">
                          Select{" "}
                          <div
                            id="select-content"
                            className="text-body fw-semibold px-1"
                          >
                            {dele}
                          </div>{" "}
                          Result{" "}
                          <button
                            type="button"
                            className="btn btn-link link-danger p-0 ms-3"
                            onClick={() => setDeleteModalMulti(true)}
                          >
                            Remove
                          </button>
                        </div>
                      </div>
                    </div>
                  </Row>
                </div>
                <div className="card-body pt-0">
                  {/* {productList && productList.length > 0 ? ( */}
                  {filteredProductList ? (
                    <TableContainer
                      columns={columns}
                      data={filteredProductList || []}
                      isGlobalFilter={true}
                      customPageSize={10}
                      divClass="table-responsive mb-1"
                      tableClass="align-top table-bordered align-top table-nowrap mb-0"
                      theadClass="table-light fw-bold"
                      isProductsFilter={true}
                      SearchPlaceholder="Search Products..."
                    />
                  ) : (
                    <div className="py-4 text-center">
                      <div>
                        <i className="ri-search-line display-5 text-success"></i>
                      </div>

                      <div className="mt-4">
                        <h5>Sorry! No Result Found</h5>
                      </div>
                    </div>
                  )}
                </div>
              </Card>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default EcommerceProducts;
